import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PITCH_TYPES } from 'yankees-react-utils';

export const CACHED_FILTER_TYPES = {
    matchupReport: 'matchup-report',
    gamePrep: 'game-prep',
};

const PREFIX = 'nyy-pp-cached-filters';
const getKey = (type, playerId) => {
    if (!type) throw new Error('Must have type for cached filters hook');
    if (!playerId) throw new Error('Must have player id for cached filters hook');

    return `${PREFIX}-${type}-${playerId}`;
};

export default function useCachedFilters({
    type,
    playerId,
    defaultFilters,
} = { }) {
    const { t: translate } = useTranslation();
    const getCachedFilters = useCallback(() => {
        const key = getKey(type, playerId);
        if (window.$IsDugoutApp) {
            return {
                ...defaultFilters,
                showing: 3,
                pitchTypes: [...PITCH_TYPES(translate).map(({ id }) => id), 3033, 3034],
            };
        }

        try {
            return JSON.parse(sessionStorage.getItem(key)) || defaultFilters;
        } catch {
            return defaultFilters;
        }
    }, [type, playerId, defaultFilters, translate]);

    const updateCachedFilters = useCallback((newFilter) => {
        const key = getKey(type, playerId);

        sessionStorage.setItem(key, JSON.stringify(newFilter));
    }, [type, playerId]);

    const clearAll = () => {
        try {
            const keysToRemove = [];
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);

                if (key.startsWith(PREFIX)) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((key) => {
                sessionStorage.removeItem(key);
            });
        } catch {
            console.error('Error clearing cached filters');
        }
    };

    return {
        updateCachedFilters,
        getCachedFilters,
        clearAll,
    };
}
